<template>
    <div>
        <div class="header">
            <div class="logout-bg" @click="logout">
                ログアウト
            </div>
            <div class="header-title">Photo Uploader</div>

        </div>
        <div class="div-customer-search">
            <div style="margin: 1vw; font-size: 2.4vw;">あいまい検索</div>
            <input class="input-customer-name" placeholder="" v-model="searchKey"
            >
            <div class="btn-bg-search" @click="searchCustomer">検索</div>
        </div>
        <div  style="margin: 1vw; font-size: 2.4vw;"> 検索範囲は「査定」以外</div>
        <div class="container">


      <table >
        <thead>
        <tr>
          <th class="container-th" style="position: sticky;z-index: 1;top:-2px;" v-for="item in columns" v-bind:key="item.field">{{ item.label }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in rows" v-bind:key="item.Order_ID"
            :class="selectedIndex===index?'container-tr-bg-3':index%2===0?'container-tr-bg':'container-tr-bg-2'" @click="itemClick(index,item.Order_ID)">
          <div :class="selectedIndex===index?'container-tr-id-selected':'container-tr-id'">
            <a :class="selectedIndex===index?'container-tr-id-text-selected':'container-tr-id-text'"
               href="#">{{ item.Order_ID }}</a></div>
          <div :class="selectedIndex===index?'container-tr-content-selected':'container-tr-content'">
            {{  item.Car_Name}}
          </div>
          <div :class="selectedIndex===index?'container-tr-content-selected':'container-tr-content'">
            {{ dataShow ? item.name + item.customer_name : "*** ***" }}
          </div>
          <div :class="selectedIndex===index?'container-tr-content-selected':'container-tr-content'">
            {{ dataShow ? item.VIN : "*** ***" }}
          </div>
        </tr>
        </tbody>
      </table>

      <div v-if="rows.length === 0" class="container-empty">該当データはありません</div>
    </div>
    <div class="btn-bg" @click="addPhoto">
      写真を記録
    </div>
    <custom-dialog v-show="showMessage" :show-message="showMessage" :sub-message='subMessage'
                   @dialogClick="dialogClick" :type="dialogType"/>
  </div>
</template>
<script>

import {getToken} from "@/utils/request";
import {getOrderList, getSsInfo} from "@/utils/api";
import {SHOP_ID} from "@/utils/mutation-types";
import CustomDialog from "@/components/CustomDialog.vue";

export default {
    name: 'customerIndex',
    components: {CustomDialog},
    data() {
        return {
            katagana: /[^アイウエオカキクケコャュョガギグゲゴサシスセソザジズゼゾェタティトゥダデドチヂツァォヅナニヌネノハヒホヘバビブベボパピプぺポフマミムメモヤ㇙ユヨッラリルレロワヰ于ヱヲヷヸヴヹヺンーヵヶ]/g,
            countdownTime: 600,
            countdownTimeStr: '',
            searchKey: '',
            columns: [
              {
                label: 'オーダーID',
                field: 'Order_ID',
              },
                {
                    label: '車名',
                    field: 'carName',
                },
                {
                    label: 'お客様',
                    field: 'customerName',
                },
                {
                    label: '車台番号',
                    field: 'carNum',
                }
            ],
            selectedIndex: -1,
            selectedOrderId: -1,
            dataShow: true,
            rows: [],


            dialogType: 0,
            showMessage: false,
            subMessage: "",
            state: 0,
            taskId: null
        }
    },
    // watch: {
    //   'searchKey' : {
    //     handler: function (newVal) {
    //       if (newVal && newVal != '') {
    //         console.log('new '+newVal)
    //         this.searchKey = newVal.replaceAll(this.katagana, '');
    //       }
    //     }
    //   },
    // },
    mounted() {
        let that = this;
        that.taskId = setInterval(function () {
            that.countdown();

        }, 1000);

        getToken().then((res) => {
            console.log(JSON.stringify(res));
            if (res.ret === 200 && res.data.access_token) {
                localStorage.setItem('token', res.data.access_token)
                if (that.$route.params.shopId) {
                    console.log('shopId'+ that.$route.params.shopId);
                    localStorage.setItem(SHOP_ID, that.$route.params.shopId)
                    that.getOrderList();
                } else {
                    console.log("no request shopId");
                    // TODO: get ssid from login user

                    getSsInfo()
                        .then((res2) => {
                            console.log(JSON.stringify(res2));
                            if (res2.ret == 200) {
                                console.log('session shopId', res2.data.ID);
                                localStorage.setItem(SHOP_ID, res2.data.ID)
                                that.getOrderList();
                            }
                        })
                        .catch((err2) => {
                            console.log(err2);
                        })
                }
            }
        })
            .catch((err) => {
                console.log(err);
            })

    },
    beforeDestroy() {
        clearInterval(this.taskId)
    },
    created() {
        let that = this;
        // getToken();
        document.addEventListener('touchstart', function () {
            that.handleTouchStart()
        }, true);
        // that.showMessageDialog('お客様情報の有無を確認します。', 1)
    },
    methods: {
        countdown() {
            let that = this;
            let diff = that.countdownTime;
            diff--;
            if (diff <= 0) {
                window.document.location = "/ss/menu.php";
                clearInterval(that.taskId)
                return
            }

            let minutes = Math.floor((diff / 60));
            let seconds = Math.floor((diff % 60));
            that.$set(that, 'countdownTimeStr', `${minutes}:${seconds < 10 ? '0' + seconds : seconds}`)
            that.$set(that, 'countdownTime', diff)
        },
        handleTouchStart() {
            console.log('handleTouchStart')
            if (this.countdownTime !== 600) {
                this.$set(this, 'countdownTime', 600)
            }
        },
        logout() {
            this.state = -1;
            this.showMessageDialog("入力途中のデータは\n保存されません", 2)

        },
        back() {
            this.state = -2;
            this.showMessageDialog("入力途中のデータは\n保存されません", 2)
        },
        dialogClick(val) {
            this.$set(this, 'showMessage', false)
            this.$set(this, 'subMessage', '')
            if (val) {
                console.log('this.state:' + this.state);
                if (this.state === -1) {
                    window.document.location = "/ss/index.php";
                } else if (this.state === -2) {
                    this.$router.back();
                }
            }
            this.$set(this, 'state', 0)
        },
        showMessageDialog(subMessage, dialogType) {
            this.$set(this, 'showMessage', true)
            this.$set(this, 'dialogType', dialogType)
            this.$set(this, 'subMessage', subMessage)
        },

        addPhoto() {
            if (this.selectedOrderId!=-1) {
                this.$router.push('/photoReview/' + this.selectedOrderId)
            } else {
                this.showMessageDialog('車両を一つ選んでください。', 1)
            }
        },
        searchCustomer() {
            this.getOrderList();
            // if (that.searchKey) {
            //     //todo search api
            //
            // } else {
            //     this.state = 1;
            //     this.showMessageDialog('お名前のカタカナを入力してください', 1)
            // }
        },
        itemClick(index, orderId) {
            this.$set(this, 'selectedIndex', index)
            this.$set(this, 'selectedOrderId', orderId)
            // this.$router.push('/carSearchIndex/'+customerId)
        },
        getOrderList() {
            var that = this;
            var shopId = localStorage.getItem(SHOP_ID);
            that.$set(that, 'selectedIndex', -1)
            that.$set(that, 'selectedOrderId', -1)
            that.$showLoading()
            getOrderList(shopId, that.searchKey)
                .then((res) => {
                    console.log(JSON.stringify(res));
                    if (res.ret === 200) {
                        if (!res.data[0]){
                            that.rows = [];
                        }else {
                            that.rows = res.data;
                        }
                    }
                    that.$hideLoading()
                })
                .catch((res) => {
                    console.log(res);
                    that.$hideLoading()
                })
        }

  }
}
</script>

<style scoped>
.header {
  background: #416ADB;
  height: 8vw;
}

.header-title {
  color: white;
  font-size: 3vw;
  height: 8vw;
  line-height: 8vw;
  margin: 0 auto;
}

.header-countdown-time {
    display: flex;
    color: white;
    font-size: 2.2vw;
    position: absolute;
    float: right;
    right: 0;
    margin-top: 1.5vw;
    margin-right: 3.5vw;
}

.container {
    text-align: center;
    height: 40vh;
    margin: 0 auto 1vw auto;
    overflow: auto;
}
.container::-webkit-scrollbar {
    display: none;
}

.container-empty {
  width: 100%;
  padding-top: 5vh;
  text-align: center;
  margin: 0 auto;
  font-size: 2.4vw;
}

.container-th {
    width: 22vw;
    background: #89a4ca;
    color: #FFFFFF;
    font-size: 2.4vw;
    padding: 0.8vw;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
}

.container-tr-id {
    width: 22vw;
    font-size: 2.4vw;
    padding: 0.8vw;
    color: #083a7e;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
}

.container-tr-id-selected {
    width: 22vw;
    font-size: 2.4vw;
    padding: 0.8vw;
    color: #ffffff;
    border-right: 0.1vw solid #FFFFFF;
    display: table-cell;
}

.container-tr-id-text {
  color: #083a7e;
}

.container-tr-id-text-selected {
  color: #ffffff;
}

.container-tr-content-selected {
  font-size: 2.4vw;
  width: 22vw;
  padding: 0.8vw;
  text-align: left;
  color: #FFFFFF;
  border-right: 0.1vw solid #FFFFFF;
  display: table-cell;
}

.container-tr-content {
  width: 22vw;
  font-size: 2.4vw;
  padding: 0.8vw;
  text-align: left;
  border-right: 0.1vw solid #FFFFFF;
  display: table-cell;
  overflow-wrap: anywhere;
}

.container-tr-bg {
  background: #cfddee;
}

.container-tr-bg-2 {
  background: #e8f1fb;
}

.container-tr-bg-3 {
  background: #083a7e;
}

.div-customer-search {
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2vw;
}

.input-customer-name {
  padding-left: 1vw;
  width: 50vw;
  border: 0.3vw #083A7E solid;
  border-radius: 0.8vw;
  color: #212529;
  padding-top: 1vw;
  padding-bottom: 1vw;
  font-size: 2.4vw;
}

.btn-bg-search {
  margin-left: 3vw;
  background: #f7bc34;
  font-size: 2.6vw;
  text-align: center;
  align-items: center;
  padding: 1vw 2.5vw 1vw 2.5vw;
  border-radius: 0.8vw;
  color: #212529;
  border-width: 0.4vw;
  border-color: #93721f;
  border-style: none none solid none;
}

.logout-bg {
  margin: 1.5vw 3vw;
  background: #e7373d;
  font-size: 2.4vw;
  padding: 0.8vw 5vw;
  border-radius: 0.8vw;
  color: #FFFFFF;
  border-width: 0.4vw;
  border-color: #891F25;
  border-style: none none solid none;
  position: absolute;
  right: 3vw;
}

.btn-bg {
  margin: 2vw auto;
  padding: 1vw;
  border-radius: 1vw;
  opacity: 1;
  border-bottom: #083A7E 0.2vw;
  border-style: none none solid none;
  background: #416ADA;
  color: #FFFFFF;
  font-size: 2.6vw;
  width: 40vw;
}
</style>